import React, {createContext} from "react";
import PropTypes from "prop-types";
import {ENTITY_TYPE} from "utils/entities";

export const EntityListContext = createContext();

// @todo: Refactor repetitive prop passing to use context
export const EntityListProvider = ({
  children,
  data,
  entityType,
  selectable,
  selected,
  setSelected,
  withDrawer
}) => (
  <EntityListContext.Provider
    value={{
      data,
      entityType,
      selectable,
      selected,
      setSelected,
      withDrawer
    }}>
    {children}
  </EntityListContext.Provider>
);

EntityListProvider.propTypes = {
  children: PropTypes.any,
  /**
   * Object of data for entity
   */
  data: PropTypes.array,
  /**
   * String name for entity
   */
  entityType: PropTypes.oneOf(Object.values(ENTITY_TYPE)),
  /**
   * If true, checkboxes will be applied
   *
   * @defaultValue false
   */
  selectable: PropTypes.bool,
  /**
   * State for selected checkboxes
   * @remark selectable={true} is required
   */
  selected: PropTypes.array,
  /**
   * Function to set state of selected checkboxes
   * @remark selectable={true} is required
   */
  setSelected: PropTypes.func,
  /**
   * If true, drawer specific styles will be added
   *
   * @example tooltip will be positioned left for long values wider than drawer
   *
   * @defaultValue false
   */
  withDrawer: PropTypes.bool
};
